import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flex: '1 1 auto',
    flexDirection: 'column',
    marginBottom: '1rem',
    boxShadow: '0 0.125rem 0.375rem 0 rgb(0 0 0 / 8%)',
    borderRadius: '0.5rem',
    boxSizing: 'border-box',
    height: 'auto',
    maxWidth: 'calc(100vw - 10rem)',
    padding: '2rem',
    backgroundColor: 'white',

    [theme.breakpoints.down(900)]: {
      maxWidth: 'calc(100% - 2rem)'
    }
  },

  textField: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    marginBottom: '10px',
    borderBottom: '2px solid #F1F1F1',
    boxSizing: 'border-box',

    '&:focus-within': {
      borderBottom: '1px solid grey'
    },

    '& .text': {
      opacity: '0.7',
      border: 'none',
      fontSize: theme.size.lg,
      textOverflow: 'ellipsis',
      width: '75%',
      background: 'transparent',

      [theme.breakpoints.down('md')]: {
        width: 'calc(100% - 2rem)'
      }
    },

    '& .adorn': {
      marginRight: '10px'
    }
  },

  padded: {
    padding: '1rem 0'
  },

  headerButtons: {
    position: 'absolute',
    top: '0',
    right: '0',
    display: 'flex',
    alignItems: 'center',
    height: '80%'
  },

  section: {
    position: 'relative',
    borderBottom: '2px solid #F1F1F1',
    minHeight: '1.5rem', // Need this so collapse behaviour works
    marginTop: '1rem'
  },

  customFieldsSection: {
    '& > div': {
      marginTop: 0
    },
    '& > div > div:first-child > div': {
      paddingTop: 0
    }
  },

  sectionHeader: {
    display: 'flex',
    alignItems: 'center',
    position: 'absolute',
    top: '4px',
    width: '100%',
    fontSize: theme.size.sm,

    '& > div': {
      display: 'flex'
    },

    '& .icon': {
      display: 'flex',
      alignItems: 'center',
      marginRight: '4px',
      width: '1rem',
      height: '1rem'
    }
  },

  sectionButton: {
    position: 'absolute',
    top: '4px',
    right: '1rem'
  },

  infoColumn1: {
    color: 'grey',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-evenly',
    flexBasis: '50%',
    padding: '1rem 0',

    '& > div': {
      height: '35px',

      '& > span': {
        width: '150px',
        cursor: 'default'
      }
    }
  },

  infoColumn2: {
    color: 'grey',
    display: 'flex',
    flexDirection: 'column',
    flexBasis: '40%',
    padding: '1rem 0',
    justifyContent: 'space-evenly',

    '& > div': {
      height: '35px',

      '& > span': {
        width: '150px',
        cursor: 'default'
      }
    }
  },

  input: {
    width: '50%',
    outline: 'none',
    border: 'none'
  },

  center: {
    display: 'flex',
    alignItems: 'center',
    color: '#7F8487',

    '& > .MuiIconButton-root:hover': {
      backgroundColor: 'transparent'
    }
  },

  label: {
    marginRight: '0.5rem',

    '& svg': {
      marginRight: '0.5rem',
      color: 'black'
    }
  },

  body: {
    position: 'relative',
    marginTop: '10px',
    width: '100%',
    maxHeight: '90%',
    overflowY: 'auto',

    '&:not(:last-child)': {
      marginRight: '10px'
    },

    '& > *': {
      outline: 'none',
      border: 'none',
      height: '100%'
    },

    '& .text': {
      overflow: 'auto !important',
      width: '100%',
      height: '75% !important',
      backgroundColor: 'transparent',
      color: '#323436',
      resize: 'none',

      '& div > div > textarea.text__input': {
        padding: '0 !important'
      }
    },

    '& > .count': {
      position: 'absolute',
      right: '1.5rem',
      top: '0',
      height: 'auto',
      color: 'rgba(50, 52, 54, 0.35)',
      userSelect: 'none'
    }
  },

  transparent: {
    '& > div > input': {
      border: 'none',
      backgroundColor: 'white',
      outline: 'none',
      padding: '0',
      width: '50%'
    },

    '& > div > input:focus': {
      boxShadow: 'none',
      borderColor: 'none'
    }
  },

  description: {
    marginBottom: '1rem',
    height: '1rem'
  },

  subtask: {
    height: '20px',
    paddingBottom: '1rem',
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer'
  },

  backButton: {
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    fontSize: theme.size.sm,
    userSelect: 'none',
    color: '#7F8487',

    '& .icon': {
      marginRight: '0.25rem',
      color: theme.palette.primary.main,
      fontSize: theme.size.base,
      width: '1rem',
      height: '1rem'
    }
  },

  parentTitle: {
    fontSize: theme.size.base,
    color: theme.palette.primary.main,
    cursor: 'pointer',
    marginTop: '1rem'
  },

  menu: {
    display: 'flex',
    alignItems: 'center',
    marginLeft: '0.5rem',
    height: 'calc(100% - 1.125rem)'
  },

  menuIcon: {
    fontSize: theme.size.base,
    color: theme.palette.primary.main,
    cursor: 'pointer',
    width: '1rem',
    height: '1rem'
  },

  saveButton: {
    margin: '1.5rem auto 3rem auto',
    width: '50%',
    padding: '8px 12px',
    fontSize: theme.size.sm,

    '& .icon': {
      marginRight: '0.5rem'
    }
  },

  branchIcon: {
    transform: 'rotate(90deg)'
  },

  closedTaskVisibility: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginLeft: '0.5rem',
    cursor: 'pointer',
  },

  headerWithActions: {
    alignItems: 'center',
    gap: 4
  },

  buttonMenuIcon: {
    cursor: 'pointer'
  }
}))

export default useStyles
